/* Small, progressively enhanced presentation layer. No cart writes or price calculations. */
(() => {
  'use strict';
  if (window.BPCartPresentation) return;
  window.BPCartPresentation = true;
  const drawer = document.querySelector('cart-drawer');
  let scrollTop = 0, scheduled = false, codeOpen = false, codeValue = '', rememberedFocus = null;
  const codeSelector = '[data-bp-cart-code]';
  function availability() {
    let config;
    try { config = JSON.parse(document.querySelector('[data-bp-nav-world-config]')?.textContent || '{}'); } catch { return; }
    const now = window.BPLaunch?.now?.() || Date.now();
    document.querySelectorAll('[data-bp-cart-available]').forEach(node => {
      const available = node.dataset.bpCartAvailable === 'lip' ? config.lip === true :
        config.event === true && now >= Date.parse(config.starts) && now < Date.parse(config.ends);
      node.hidden = !available;
    });
  }
  function refresh() {
    scheduled = false;
    const inner = drawer?.querySelector('.drawer__inner');
    if (inner) inner.inert = !drawer.hasAttribute('open');
    if (drawer?.hasAttribute('open') && drawer.dataset.toggleTabindex) {
      drawer.querySelectorAll(drawer.dataset.toggleTabindex).forEach(control => control.setAttribute('tabindex', '0'));
    }
    const scroller = drawer?.querySelector('.wt-cart__drawer__body');
    if (scroller && scrollTop) scroller.scrollTop = scrollTop;
    document.querySelectorAll(codeSelector).forEach(details => {
      if (codeOpen && !details.open) details.open = true;
      const input = details.querySelector('input');
      if (input && codeValue && document.activeElement !== input && !input.value) input.value = codeValue;
    });
    availability();
    if (rememberedFocus && drawer?.hasAttribute('open') && (document.activeElement === document.body || document.activeElement?.classList.contains('wt-cart__drawer__close--button'))) {
      const row = Array.from(drawer.querySelectorAll('[data-bp-cart-key]')).find(node => node.dataset.bpCartKey === rememberedFocus.key);
      const target = row?.querySelector(rememberedFocus.selector);
      if (target && !target.disabled) target.focus({preventScroll:true});
    }
  }
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(refresh); } };
  document.addEventListener('scroll', event => {
    if (event.target.matches?.('#CartDrawer .wt-cart__drawer__body')) scrollTop = event.target.scrollTop;
  }, true);
  document.addEventListener('input', event => {
    if (event.target.matches('[data-bp-cart-discount] input')) codeValue = event.target.value;
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches?.(codeSelector)) codeOpen = event.target.open;
  }, true);
  document.addEventListener('click', event => {
    const control = event.target.closest('.js-counter-button, cart-remove-button');
    if (!control) { rememberedFocus = null; return; }
    const row = control.closest('[data-bp-cart-key]');
    if (row) rememberedFocus = {key:row.dataset.bpCartKey, selector:control.matches('.js-counter-increase') ? '.js-counter-increase' : control.matches('.js-counter-decrease') ? '.js-counter-decrease' : '.js-counter-quantity'};
  }, true);
  if (drawer) {
    new MutationObserver(records => {
      if (records.some(record => record.type === 'attributes' || Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches?.('.drawer__inner, .wt-cart__list, cart-drawer-items, .bp-cart-code') || node.querySelector?.('.drawer__inner, .wt-cart__list, cart-drawer-items, .bp-cart-code'))))) schedule();
    }).observe(drawer,{childList:true,subtree:true,attributes:true,attributeFilter:['open']});
  }
  document.addEventListener('bp:launch:cart', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true});
  else refresh();
})();
